class ContractType {
  static AGREEMENT = 'agreement';
  static CONTRACT = 'contract';

  constructor(private code: string) {}

  public value(): string {
    return this.code;
  }

  public static toArray(): string[] {
    return [ContractType.AGREEMENT, ContractType.CONTRACT];
  }

  public isAgreement(): boolean {
    return this.code === ContractType.AGREEMENT;
  }

  public isContract(): boolean {
    return this.code === ContractType.CONTRACT;
  }
}

export default ContractType;
